// section animation  
document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('[os-animation]');
  const trigger = window.innerHeight * 0.9;
  const handleCardVisibility = () => {
    items.forEach(elm => {
      const rect = elm.getBoundingClientRect();
      elm.classList.add('os-animation');
      if (rect.top < trigger && !elm.classList.contains('animated')) {
        elm.classList.add('animated');
      } else if(!elm.classList.contains('animated')) {
        elm.classList.remove('animated');
      }
    });
  };

  handleCardVisibility();
  window.addEventListener('scroll', handleCardVisibility);
});
// global function start for slick slider 
class ResponsiveSlick {
  constructor(selector, breakpoints) {
    this.selector = selector;
    this.breakpoints = breakpoints;
    this.init = false;

    // Initialize and attach the resize event listener
    this.slickCard();
    window.addEventListener("resize", this.slickCard.bind(this));
  }

  initSlick(options) {
    $(this.selector).slick(options);
  }

  destroySlick() {
    if ($(this.selector).hasClass('slick-initialized')) {
      $(this.selector).slick('unslick');
    }
  }

  getOptionsForWidth(width) {
    for (let breakpoint in this.breakpoints) {
      if (width <= breakpoint) {
        return this.breakpoints[breakpoint];
      }
    }
    return null;
  }

  slickCard() {
    const width = window.innerWidth;
    const options = this.getOptionsForWidth(width);

    if (options) {
      if (!this.init) {
        this.init = true;
        this.initSlick(options);
      } else {
        // If the options have changed, reinitialize the slider
        this.destroySlick();
        this.initSlick(options);
      }
    } else if (this.init) {
      this.destroySlick();
      this.init = false;
    }
  }
}

// global function end for slick slider 

const icon__breakpoints = {
  989: {
    slidesToShow: 3,
    dots: true,
    arrows: false,
    infinite: true,
  },
  749: {
    arrows: false,
    slidesToShow: 2,
    dots: true,
    infinite: false,
  }
};
const save_breakpoints = {
  759: {
    slidesToShow: 2,
    arrows: false,
    dots: true,
    infinite: false,
  },
  499: {
    arrows: false,
    slidesToShow: 1,
    dots: true,
    infinite: false,
  }
};

const ppp_breakpoints = {
  749: {
    slidesToShow: 1.5,
    dots: true,
    arrows: false,
    infinite: false,
  },
  499: {
    arrows: false,
    slidesToShow: 1.1,
    dots: true,
    infinite: false,
  }
};

const hbl_breakpoints = {
  749: {
    slidesToShow: 1.5,
    dots: true,
    arrows: false,
    infinite: false,
  },
  499: {
    arrows: false,
    slidesToShow: 1.3,
    dots: true,
    infinite: false,
  }
};

const ppp2_breakpoints = {
  5000: {
    slidesToShow: 3,
    dots: true,
    arrows: false,
    infinite: false,
  },
  1199: {
    slidesToShow: 2,
    dots: true,
    arrows: false,
    infinite: false,
  },
  749: {
    slidesToShow: 1.5,
    dots: true,
    arrows: false,
    infinite: false,
  },
  499: {
    slidesToShow: 1.2,
    dots: true,
    arrows: false,
    infinite: false,
  }
};

const price_feature_breakpoints = {
  749: {
    slidesToShow: 2.4,
    dots: true,
    arrows: false,
    infinite: false,
  },
  499: {
    slidesToShow: 2,
    dots: true,
    arrows: false,
    infinite: false,
  }
};
const image_slider_option = {
  15000: {
    slidesToShow: 1,
    dots: false,
    arrows: true,
    infinite: true,
    centerMode: true,
  }
};

const worth_barken_option = {
  15000: {
    slidesToShow: 3,
    dots: false,
    arrows: true,
    infinite: true,
    centerMode: false,
  },
  992: {
    slidesToShow: 2,
    dots: false,
    arrows: true,
    infinite: false,
  },
  575: {
    slidesToShow: 1,
    dots: false,
    arrows: true,
    infinite: false,
  }
};

const innner_hero_option = {
  15000: {
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false,
    dots: true,
    arrows: false,
  },
  992: {
    adaptiveHeight: true,
    speed: 400,
    cssEase: 'ease',
    easing: 'swing',
    dots: true,
    arrows: false,
  }
};

const premium_ingredients_slider = {
  1199: {
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
    arrows: true, 
    infinite: true, 
  },
  649: {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true, 
    adaptiveHeight: true,
    speed: 400,
    cssEase: 'ease',
    easing: 'swing',
  }
};


const iconsBlocksSlider = new ResponsiveSlick(".icons-blocks-slider", icon__breakpoints);
const saveSlider = new ResponsiveSlick(".save__slider", save_breakpoints);
const pppSlider = new ResponsiveSlick(".ppp-slider", ppp_breakpoints);
const hblSlider = new ResponsiveSlick(".hbl-slider", hbl_breakpoints);
const ppp2Slider = new ResponsiveSlick(".ppp2-slider", ppp2_breakpoints);
const priceFeatureSlider = new ResponsiveSlick(".price-feature-slider", price_feature_breakpoints);
const imageSlider = new ResponsiveSlick(".image-slider", image_slider_option);
const worthBarkenSlider = new ResponsiveSlick(".worth-barken-slider", worth_barken_option);
const innnerHeroSldier = new ResponsiveSlick(".innner-hero-sldier", innner_hero_option);
const premiumIngredientsSlider = new ResponsiveSlick(".premium-ingredients-slider", premium_ingredients_slider);

// acccordion start
(function Accordion() {
  const triggers = document.querySelectorAll('[data-toggle="collapse"]');
  let activeToggle;
  triggers &&
    triggers.forEach((trigger) => {
      trigger.collapseTarget = document.querySelector(
        trigger.hash || trigger.dataset.target
      );

      trigger.collapseTarget.dataset.parent &&
        trigger.collapseTarget.classList.contains("is-active") &&
        (activeToggle = trigger);

      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggle(trigger);
      });

      // Remove height when end open transition
      trigger.collapseTarget.addEventListener("transitionend", ({ target }) => {
        if (!target.classList.contains("is-active")) return;

        target.style.height = null;
      });
    });
  function toggle(trigger) {
    if (trigger.collapseTarget.classList.contains("is-active")) {
      close(trigger);
      activeToggle = null;
    } else {
      activeToggle &&
        activeToggle.collapseTarget.dataset.parent &&
        close(activeToggle);

      trigger.collapseTarget.dataset.parent && (activeToggle = trigger);

      open(trigger);
    }
  }
  function close(trigger) {
    setHeight(trigger.collapseTarget);

    trigger.parentElement.classList.remove("is-active");
    trigger.classList.remove("is-active");
    trigger.collapseTarget.classList.remove("is-active");

    setTimeout(() => {
      trigger.collapseTarget.style.height = null;
    }, 0);
  }
  function open(trigger) {
    trigger.classList.add("is-active");
    trigger.parentElement.classList.add("is-active");

    setTimeout(() => {
      setHeight(trigger.collapseTarget);
      trigger.collapseTarget.classList.add("is-active");
    }, 0);
  }
  function setHeight(target) {
    target.style.height = target.scrollHeight + "px";
  }
})();

$(document).ready(function () {
  $(".product__image-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: true,
    autoplay: false,
    prevArrow: '<button class="slick-prev slick-arrow"></button>',
    nextArrow: '<button class="slick-next slick-arrow"></button>',
  });
  $('.mm-slider_title').slick({
     arrows: false,
     fade: true,
     variableWidth:true,
     focusOnSelect: true,
     accesibility: false,
     draggable: false,
     swipe: false,
     touchMove: false,
     asNavFor: '.mmd-slider, .mm-img-slider, .mm-slider'
   });

  $('.mm-slider').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     arrows: false,
     fade: true,
     adaptiveHeight: false,
    accesibility: false,
    draggable: false,
    swipe: false,
    touchMove: false,
     asNavFor: '.mmd-slider, .mm-img-slider, mm-slider_title'
   });
   $('.mmd-slider').slick({
     slidesToShow: 3,
     slidesToScroll: 1,
     variableWidth:true,
     asNavFor: '.mm-slider, .mm-img-slider, .mm-slider_title',
     focusOnSelect: true
   });
   $('.mm-img-slider').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     arrows: false,
     fade: true,
     asNavFor: '.mmd-slider, .mm-slider, .mm-slider_title',
     responsive: [
      {
        breakpoint: 990,
        settings: {
          centerMode: true,
        },
      },
     ]
  });
  // $(".product__image-slider").slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   dots: true,
  //   infinite: true,
  //   autoplay: false,
  //   prevArrow: '<button class="slide-arrow prev-arrow"></button>',
  //   nextArrow: '<button class="slide-arrow next-arrow"></button>',
  // });

  $(document).ready(function(){
  // Initialize the Slick sliders
  $('.hy-slider').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     arrows: false,
     fade: true,
     accesibility: false,
     draggable: false,
     swipe: false,
     touchMove: false,
     asNavFor: '.hy-slider-title, .hy-img-slider, .hyd-slider',
  });

  $('.hy-slider-title').slick({
     arrows: false,
     fade: true,
     variableWidth:true,
     focusOnSelect: true,
     accesibility: false,
     draggable: false,
     swipe: false,
     touchMove: false,
     asNavFor: '.hy-slider, .hyd-slider, .hy-img-slider'
   });
  $('.hyd-slider').slick({
     slidesToShow: 3,
     slidesToScroll: 1,
     variableWidth: true,
     asNavFor: '.hy-slider, .hy-img-slider, .hy-slider-title',
     focusOnSelect: true
  });

  $('.hy-img-slider').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     arrows: false,
     fade: true,
     asNavFor: '.hy-slider, .hyd-slider, .hy-slider-title',
     responsive: [
      {
        breakpoint: 990,
        settings: {
          centerMode: true,
        },
      },
     ]
  });

  // Tab click event
  $('.tab__links').click(function() {
    var index = $(this).parent().index();
    $('.hy-slider').slick('slickGoTo', index);
    $('.hyd-slider').slick('slickGoTo', index);
    $('.hy-img-slider').slick('slickGoTo', index);
  });
});

    $('.our-mission-slider').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      infinaite : false,
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1.25,
            dots: true,
            arrows: false,
            infinite: false,
          }
        },
        {
          breakpoint: 390,
          settings: {
            arrows: false,
            slidesToShow: 1.15,
            dots: true,
            infinite: false,
          }
        }
      ]
   });
});
  // tabs script ======== 
  $(document).ready(function() {
      $('.tab__link').click(function() {
          $(this).parents(".tabs-parent").find(".tab").removeClass('tab__active');
          $(".tab[data-id='" + $(this).attr('data-id') + "']").addClass("tab__active");
          $(this).parents(".tabs-parent").find(".tab__link").removeClass('active');
          $(this).parent().find(".tab__link").addClass('active');
      });
  });


$(document).ready(function() {
	$('.popup-youtube').magnificPopup({
    type: 'iframe'
  });
});



mobileOnlySlider(".feature-collection-slider", true, true, 749);
function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
	var slider = $($slidername);
	var settings = {
		mobileFirst: true,
		dots: $dots,
		arrows: $arrows,
		responsive: [
			{
				breakpoint: $breakpoint,
				settings: "unslick"
			}
		]
	};
	slider.slick(settings);
	$(window).on("resize", function () {
		if ($(window).width() > $breakpoint) {
			return;
		}
		if (!slider.hasClass("slick-initialized")) {
			return slider.slick(settings);
		}
	});
}
